import * as types from "../types/permission.types";
import {
  getPermissionList,
} from "../../services/permission.service";
import { validationErrors } from "../../utils/Helpers";

export const getPermissionListAction = () => {
  return async (dispatch, getState) => {
    try {
      await getPermissionList(
        getState().authReducer.token,
        getState().authReducer.user.id,
      ).then((res) => {
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_PERMISSIOM_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const resetPermissionReducerAction = (data) => {
  return async (dispatch) => {
    dispatch({
      type: types.RESET_PERMISSION_REDUCER,
    });
  };
};
